<template>
  <v-card>
    <v-layout mx-4 pt-4 wrap>
      <v-flex md10>
        <v-text-field
          id="addressLine1"
          name="addressLine1"
          label="Endereço"
          v-model="address.addressLine1"
        ></v-text-field>
      </v-flex>
      <v-flex md2>
        <v-text-field
          id="addressLine2"
          name="addressLine2"
          label="Núm."
          v-model="address.addressLine2"
        ></v-text-field>
      </v-flex>
      <v-flex md6>
        <v-text-field
          id="addressLine3"
          name="addressLine3"
          label="Complemento"
          v-model="address.addressLine3"
        ></v-text-field>
      </v-flex>
      <v-flex md6>
        <v-text-field
          id="district"
          name="district"
          label="Bairro"
          v-model="address.district"
        ></v-text-field>
      </v-flex>
      <v-flex md6>
        <v-text-field
          id="city"
          name="city"
          label="Cidade"
          v-model="address.city"
        ></v-text-field>
      </v-flex>
      <v-flex md4>
        <v-text-field
          id="postalCode"
          name="postalCode"
          label="CEP"
          v-model="address.postalCode"
        ></v-text-field>
      </v-flex>
      <v-flex md2>
        <v-text-field
          id="stateCode"
          name="stateCode"
          label="UF"
          v-model="address.stateCode"
        ></v-text-field>
      </v-flex>
    </v-layout>
  </v-card>
</template>
<script>
export default {
  name: "address-card",
  props: ["address"]
};
</script>
